<template>
  <v-card @mouseover="hover = true" @mouseleave="hover = false" :class="hover ? 'elevation-10 pointer' : 'elevation-3 pointer'" @click="$emit('clicked')" style="position:relative;">
    <div>
      <p :class="{'mb-0 text-center py-1 font-weight-bold': true, 'grey lighten-2': item.isServiceItem, 'red white--text': item.isSpecialSale}" style="font-size:10px;">
        <span v-if="item.isServiceItem">PRESUPUESTO</span>
        <span v-if="item.isSpecialSale">PROMOCIÓN</span>
      </p>
    </div>
    <span class="discount" style="z-index:1;" v-if="item.isSpecialSale">
      <h2>-{{ item.special_sale.discount }}%</h2>
    </span>
    <v-card-text v-if="item.isServiceItem || item.quotationListed">
      <p class="mb-0" style="font-size:11px;">{{service.serviceName}}</p>
      <h2 class="font-weight-light primary--text">{{item.service_items[0].description}}</h2>
      <p class="mb-0"><small>{{text}}</small><br> {{$moment(item.created_at).format('ddd DD MMM YYYY | HH:mm')}}</p>
    </v-card-text>
    <v-card-text v-if="item.isSpecialSale">
      <p class="mb-0" style="font-size:11px;">{{service.serviceName}}</p>
      <h2 class="font-weight-light primary--text">{{item.special_sale.service_item.description}}</h2>
      <p class="mb-0"><small>{{text}}</small><br> {{$moment(item.created_at).format('ddd DD MMM YYYY | HH:mm')}}</p>
    </v-card-text>
    <v-card-text class="primary pa-3 clip" style="position:relative;">
      <Estado v-if="showStatusIcon" :quotation="item.quoted"></Estado>
      <v-container grid-list-xs class="pa-0">
        <v-layout row wrap align-center fill-height>
          <v-flex xs4>
            <img class="elevation-5" src="@/assets/img/user.jpg" alt="" style="max-width:100%;">
          </v-flex>
          <v-flex xs8 class="px-0 white--text">
            <h6 class="font-weight-light">Solicitado por:</h6>
            <h4>{{user.first_name}} {{user.last_name}}</h4>
            <h6>{{user.email}}</h6>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    text: {
      type: String
    },
    showStatusIcon: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Estado: () => import('@/components/panel-data/Estado')
  },
  data() {
    return {
      hover: false,
      service: {}
    }
  },
  mounted() {
    if (this.item.isServiceItem)
      this.service = this.services.find(el => el.serviceItemId === this.item.service_items[0].id)
    else if (this.item.isSpecialSale)
      this.service = this.services.find(el => el.serviceItemId === this.item.special_sale.service_item.id)
  }
}
</script>
<style scoped>
img {
  max-width: 100%;
  width: 60px;
  border-radius: 100%;
  display: block;
  margin: 0 auto;
}
.clip {
  clip-path: polygon(0 0, 9% 0, 18% 13%, 26% 0, 100% 0, 100% 100%, 0 100%)
}
.pointer {
  cursor: pointer;
}
.discount {
  background-color: red;
  color: white;
  display: inline-block;
  padding: 4px 10px;
  position: absolute;
  top: 40px;
  right: 0;
}
.discount h2 {
  font-weight: 900;
}
</style>
